import { render } from "./NavTopBar.vue?vue&type=template&id=2ba81d80&scoped=true"
import script from "./NavTopBar.vue?vue&type=script&lang=js"
export * from "./NavTopBar.vue?vue&type=script&lang=js"

import "./NavTopBar.vue?vue&type=style&index=0&id=2ba81d80&lang=scss&scoped=true"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba81d80"]])

export default __exports__